module.exports = __webpack_public_path__ + "img/Users.9ead1b02.svg";